import React from 'react';

import { List } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

import { NavListItem } from '../NavListItem';
import { NavListItemProps } from '../NavListItem/NavListItem';

export interface NavListProps {
  className?: string;
  items?: NavListItemProps[];
}

const useStyles = makeStyles(() => ({
  navList: {
    display: 'flex',
    flexFlow: 'column nowrap',
    width: '100%',
  },
}));

export function NavList(props: NavListProps): JSX.Element {
  const classes = useStyles();
  const { className = '', items } = props;

  const navListStyles = clsx('fd-list', classes.navList, className || '');

  return (
    <List className={navListStyles} component="ul">
      {items?.map((item) => (
        <NavListItem
          disabled={item.disabled}
          elements={item.elements}
          key={item.linkId}
          linkCallback={item.linkCallback}
          linkId={item.linkId}
          linkPath={item.linkPath}
          variant={item.variant}
        />
      ))}
    </List>
  );
}
